import React, { Component } from "react";
import AboutComponent from './components/AboutComponent';
import "./../Home/assets/css/fontawesome.css";
import "./../Home/assets/css/templatemo-finance-business.css";
import "./../Home/assets/css/owl.css";


export class AboutContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the About page
        }
    }

    render(){
        return(
            <AboutComponent/>
        )
    }
          
        
}

AboutContainer.defaultProps={

}
AboutContainer.propTypes = {

}

export default(AboutContainer);